import { render } from "./RacerList.vue?vue&type=template&id=5f9a54ca&scoped=true"
import script from "./RacerList.vue?vue&type=script&lang=js"
export * from "./RacerList.vue?vue&type=script&lang=js"

import "./RacerList.vue?vue&type=style&index=0&id=5f9a54ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9a54ca"]])

export default __exports__